interface IContainer {
  children: React.ReactNode;
}
const Container = ({ children }: IContainer) => {
  return <div className="mx-auto w-[1440px]">{children}</div>;
};
export default Container;
